import { ReferralFormSettings } from '@packages/core-shared';
import { useEffect, useState } from 'react';

// Resolved organization settings for the public referral form (display flags
// only — served by an unauthenticated endpoint). While loading or on failure
// the optional fields stay hidden, matching the "(root)" default.
export const useFetchReferralFormSettings = (organizationId: string) => {
  const [settings, setSettings] = useState<ReferralFormSettings | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/organizations/${organizationId}/referral-form-settings`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        if (response.ok) {
          setSettings(await response.json());
        } else {
          console.error('Failed to fetch the referral form settings');
        }
      } catch (error) {
        console.error(error);
      }
    };
    load();
  }, [organizationId]);

  return { settings };
};
